/* eslint-disable sonarjs/no-duplicate-string */
import { Feature, Geometry } from 'geojson';
import { CircleLayer, SymbolLayer } from 'mapbox-gl';

export const MEDIA_ICON_IMAGE = 'media-icon';

export const getObservationMarkersSourceId = (configurationId: string) => `observation-markers-${configurationId}`;
export const getClusterLayerId = (configurationId: string) => `media-map-cluster-${configurationId}`;
export const getClusterCountLayerId = (configurationId: string) => `media-map-cluster-count-${configurationId}`;
export const getUnclusteredPointLayerId = (configurationId: string) => `media-map-unclustered-point-${configurationId}`;
export const getUnclusteredPointIconLayerId = (configurationId: string) =>
  `media-map-unclustered-point-icon-${configurationId}`;

export const getObservationMarkerLayers = (configurationId: string) => [
  getClusterLayerId(configurationId),
  getClusterCountLayerId(configurationId),
  getUnclusteredPointIconLayerId(configurationId),
  getUnclusteredPointLayerId(configurationId),
];

export const getClusterLayer = (configurationId: string): CircleLayer => ({
  id: getClusterLayerId(configurationId),
  type: 'circle',
  source: getObservationMarkersSourceId(configurationId),
  filter: ['has', 'point_count'],
  paint: {
    'circle-color': ['case', ['boolean', ['feature-state', 'hover'], false], '#F3EDD3', '#ffffff'],
    'circle-stroke-width': 15,
    'circle-stroke-color': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      '#F3EDD3',
      ['boolean', ['feature-state', 'active'], false],
      '#F3EDD3',
      '#ffffff',
    ],
    'circle-radius': 20,
  },
});

export const getClusterCountLayer = (configurationId: string): SymbolLayer => ({
  id: getClusterCountLayerId(configurationId),
  type: 'symbol',
  source: getObservationMarkersSourceId(configurationId),
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-size': 12,
  },
});

export const getUnclusteredPointLayer = (configurationId: string): CircleLayer => ({
  id: getUnclusteredPointLayerId(configurationId),
  type: 'circle',
  source: getObservationMarkersSourceId(configurationId),
  filter: ['!', ['has', 'point_count']],
  paint: {
    'circle-color': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      '#F3EDD3',
      ['boolean', ['feature-state', 'active'], false],
      '#F3EDD3',
      '#ffffff',
    ],
    'circle-stroke-width': 10,
    'circle-stroke-color': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      '#F3EDD3',
      ['boolean', ['feature-state', 'active'], false],
      '#F3EDD3',
      '#ffffff',
    ],
    'circle-radius': ['case', ['boolean', ['feature-state', 'active'], false], 17, 15],
  },
});

export const getIconLayer = (configurationId: string): SymbolLayer => ({
  id: getUnclusteredPointIconLayerId(configurationId),
  type: 'symbol',
  source: getObservationMarkersSourceId(configurationId),
  filter: ['!', ['has', 'point_count']],
  layout: {
    'icon-image': MEDIA_ICON_IMAGE,
    'icon-size': 0.3,
  },
});

export type MarkerFeature = Feature<Geometry, MediaMapLayerDataItem>;
export type MediaMapLayerDataItem = {
  longitude: string;
  latitude: string;
  value: string;
  [key: string]: string | undefined;
};

export const MAP_MEDIA_FILE_ALLOWED_FORMATS = {
  IMAGE: ['png', 'jpeg', 'jpg'],
  VIDEO: ['mp4', 'webm'],
  AUDIO: ['mp3', 'wav'],
};
